import { MiddlewareAPI } from '@reduxjs/toolkit';

import { ActionSource } from '@tdp/common/commandHandler';
import { ILogger } from '@tdp/common/telemetry';

import { IThemeReader } from './abstractions';
import { themeSlice } from './slice';

interface CreateThemeActionSourceDeps {
  logger: ILogger;
  themeReader: IThemeReader;
}

export function createThemeEventSource({
  themeReader,
  logger,
}: CreateThemeActionSourceDeps): ActionSource {
  return (api: MiddlewareAPI) => {
    themeReader.onThemeChange((nextTheme) => {
      logger.trace(`Theme changed to ${nextTheme}`);
      api.dispatch(themeSlice.actions.systemThemeChanged(nextTheme));
    });
  };
}
